module.exports = __webpack_public_path__ + "img/7-parameters.25741d86.png";